import { GetChat } from "../../../connection/chat";
import { Action, AsyncAction } from "../../../types/actions";
import { ISocketCommentProps } from "../../../types/working-model";

export const INCOMING_CHAT_MESSAGE = "INCOMING_CHAT_MESSAGE";
export function incomingChatMessage(message: ISocketCommentProps): Action {
	return {
		type: INCOMING_CHAT_MESSAGE,
		payload: message
	};
}

export const UNAPPROVE_CHAT_MESSAGE = "UNAPPROVE_CHAT_MESSAGE";
export function unapproveChatMessage(id: number): Action {
	return {
		type: UNAPPROVE_CHAT_MESSAGE,
		payload: id
	};
}

export const DELETE_CHAT_MESSAGE = "DELETE_CHAT_MESSAGE";
export function deleteChatMessage(id: number): Action {
	return {
		type: DELETE_CHAT_MESSAGE,
		payload: id
	};
}

export const UNDELETE_CHAT_MESSAGE = "UNDELETE_CHAT_MESSAGE";
export function undeleteChatMessage(message: ISocketCommentProps): Action {
	return {
		type: UNDELETE_CHAT_MESSAGE,
		payload: message
	};
}

export const LOAD_CHAT_MESSAGES = "LOAD_CHAT_MESSAGES";
export function loadChatMessages(sessionUuid: string, lang: string): AsyncAction {
	return {
		type: LOAD_CHAT_MESSAGES,
		promise: GetChat(sessionUuid, lang)
	};
}